// This file was autogenerated from /frontend/sail-next/packages/docs/src/component-examples/FormFieldGroup/disabled.story.tsx with go/sail-next-tailor-docs-publisher 

import * as React from 'react';
import { TextField, FormFieldGroup } from '@sail/ui';
export const Disabled = () => <FormFieldGroup legend="Disabling" disabled>
    <TextField label="Disabled" placeholder="Disabled" hiddenElements={['label']} />
    <TextField label="Not disabled" placeholder="Not disabled" disabled={false} hiddenElements={['label']} />
  </FormFieldGroup>;